module.exports = __webpack_public_path__ + "img/owl.2376a059.jpg";